<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}
                </router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm7>
                <div class="form-group dropbox" v-if="!letterHead.imageUrl">
                  <button
                    v-if="letterHead.imageUrl"
                    style="float: right"
                    @click="removeImage"
                    class="close"
                    type="button"
                  >
                    <v-icon color="red">cancel</v-icon>
                  </button>
                  <input
                    type="file"
                    @change="onFileChanged"
                    class="input-file"
                  />
                  <p v-if="!letterHead.imageUrl">
                    Drag your file(s) here to begin
                    <br />or click to browse
                  </p>
                </div>
                <div v-if="letterHead.imageUrl">
                  <img
                    :src="letterHead.imageUrl"
                    width="600px"
                    height="150px"
                  />
                  <button
                    style="float: right"
                    @click="removeImage"
                    class="close"
                    type="button"
                  >
                    <v-icon color="red">cancel</v-icon>
                  </button>
                </div>
              </v-flex>
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm12>
                <v-select
                  :items="shopList"
                  label="Select Shop"
                  item-text="name"
                  item-value="id"
                  v-model="letterHead.shopId"
                  :rules="rules.nameRules"
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <v-select
                  :items="typeList"
                  label="Type"
                  v-model="letterHead.type"
                  item-text="label"
                  item-value="value"
                  :rules="rules.typeRules"
                ></v-select>
              </v-flex>
              <v-flex sm12 v-if="letterHead.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="letterHead.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="letterHead.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="letterHead.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="letterHead.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="letterHead.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>
  
  <script>
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
import { LetterHeadFromRules } from "../../helpers/validation-rules";
import { shopService } from "../../services/shop-service";
import { LetterHead } from "../../models/model";
import { letterHeadService } from "../../services/letter-head-service";

export default {
  name: "LetterHeadDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "Letter Head",
        disabled: false,
        to: "letter-heads",
      },
      {
        text: "Letter Head Detail",
        disabled: true,
      },
    ],
    createdDate: "",
    updatedDate: "",
    responseError: "",
    saveLoading: false,
    rules: new LetterHeadFromRules(),
    letterHead: new LetterHead(),
    oldLetterHead: new LetterHead(),
    shopList: [],
    typeList: [],
  }),
  created() {
    this.getShopList();
    this.getAllLetterHeadTypes();
    const id = this.$route.params.id;
    if (id == "new") {
      // new Shop
    } else {
      this.getLetterHeadDetail(id);
    }
  },

  methods: {
    getAllLetterHeadTypes() {
      letterHeadService
        .getAllLetterHeadTypes()
        .then((res) => {
          res.data.forEach((type) => {
            let tempObj = { label: type, value: type };
            this.typeList.push(tempObj);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLetterHeadDetail(id) {
      letterHeadService.getLetterHeadById(id).then((res) => {
        this.letterHead = res.data;
        this.createdDate = commonService.formatDate(
          new Date(this.letterHead.createdDateInMilliSeconds)
            .toISOString()
            .substring(0, 10),
          "YYYY-MM-DD"
        );
        this.updatedDate = commonService.formatDate(
          new Date(this.letterHead.updatedDateInMilliSeconds)
            .toISOString()
            .substring(0, 10),
          "YYYY-MM-DD"
        );
        this.oldLetterHead = Object.assign({}, res.data);
      });
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;

          letterHeadService
            .saveLetterHead(this.letterHead)
            .then((res) => {
              console.log(res);
              this.goBack();
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
              }
              this.saveLoading = false;
            });
        }
      }
    },
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.letterHead.id) {
        this.letterHead = new LetterHead();
      } else {
        this.letterHead = Object.assign({}, this.oldLetterHead);
      }
    },
    goBack() {
      this.$router.push("/letter-heads");
    },
    removeImage() {
      this.letterHead.imageUrl = null;
    },
    onFileChanged(event) {
      const file = event.target.files[0];
      this.letterHead.imageUrl = URL.createObjectURL(file); // to show preview image
      commonService.getBase64(file).then(data => {
        this.letterHead.image = data;
      });
    },
  },
};
</script>
  